// Generated from Orval's request-header helper. Do not edit manually.
export const getHeaders = (
  h?: NonNullable<RequestInit["headers"]>,
): Record<string, string | readonly string[]> => {
  if (!h) return {};
  if (h instanceof Headers) return Object.fromEntries(h.entries());
  if (Symbol.iterator in h) {
    return Object.fromEntries(
      Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
    );
  }
  const headers: Record<string, string | readonly string[]> = {};
  for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
    if (value !== undefined) headers[name] = value;
  }
  return headers;
};
